// extracted by mini-css-extract-plugin
module.exports = {"statusBadge":"StatusBadge_statusBadge__uoj0_"};